






































































































import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';
import { Uploader, Icon, Toast, Tag, Swipe, SwipeItem } from 'vant';
import Api from "../../api";
import Public from '../../common/Public'
import Routers from "../../router/RouterTypes";
import BlankPage from '../../components/BlankPage.vue'

interface caseItem {
    clinicSeq: string,
    departmentId: string,
    departmentName: string,
    diagnosis: string,
    doctorId: string,
    doctorName: string,
    hospitalId: string,
    hospitalName: string,
    inpatientId: string,
    medicalDate: string,
    medicalType: string,
    remak: string
}
@Component({
    components: {
        [Icon.name]: Icon,
        [Uploader.name]: Uploader,
        [Tag.name]: Tag,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        BlankPage
    },
    filters:{
        filterHealthCardNo(val){
            const maxlen = 16
            if(val && val.length > maxlen ){
                return val.substring(0,maxlen) + '...'
            }else{
                return val
            }
        },
    }
})



export default class IllnessDescription extends Vue {
    currentImg = '';
    showCurrentImg = false;
    problemValue = '';
    doctorMsg:object = {};
    patientAndIn = {};
    isScroll: boolean = false;
    // caseList: Array<caseItem> = [];
    caseList: Array<caseItem> = [];
    imgList = [];
    moved = false;
    doctorImg = require('../../assets/icon_yisheng_nan.png');
    caseDefaultImg = require('../../assets/icon_zhanweitu.png');
    blankImg = require('../../assets/pic_jilu@3.png');
    defaultSwiper = 0;

    errImg(e){
        Public.doctorErrorImg(e);
    }

    scanImg(item, index){
        this.defaultSwiper = index;
        this.showCurrentImg = true;
        this.currentImg = item.imgUrl;
    }
    closeImg(){
        if (this.moved === true) {
            this.moved = false;
            return;
        }
        this.showCurrentImg = false;
    }

    loadImg(){
        console.log(2143423);
    }
    handleTouchMove() {
        this.moved = true;
    }

    errorImg(img, index){
        console.log(3333);
        console.log()
        let arr = [];
        for (let i = 0; i < this.imgList.length; i++){
            arr[i] = this.imgList[i];
        }
        arr[index].imgUrl = this.caseDefaultImg;
        this.imgList = arr;
    }
    // 判断页面是否有滚动条
    isScrollFun(){
        const _this = this;
        setTimeout(() => {
            const dom = _this.$refs.copyRight;
            console.log(document.body.clientHeight)
            if (!dom) return ;
            if ((dom as any).scrollHeight > document.body.clientHeight){
                _this.isScroll = true
            } else {
                _this.isScroll = false
            }
        })
    }

    goDetail(item){
        const itemVlue = item || {};
        const params = {};

        (params as any).clinicSeq = item.clinicSeq;
        (params as any).doctorId = item.doctorId;
        (params as any).inpatientId = item.inpatientId;
        (params as any).hospitalId=item.hospitalId;
        this.$router.push({
            name: Routers.INTER_CASE_HISTORY_HIS,
            query: params
        })
    }

    async mounted(){

        try {
            const {inqueryId, patientId} = this.$route.query as any;
            const params = {
                inqueryId: inqueryId,
                patientId: patientId
            };

            const res = await Api.idt.illnessDetail(params);
            if (res){
                const { patientName, patientCard, inqueryContent, imgList, medicalRecordList, icon , doctorTitle, doctorName, doctorContent, departmentName } = res.data;
                //成功执行
                this.patientAndIn = {
                    patientName: patientName,
                    healthCardNo: patientCard,
                    description: inqueryContent,
                };
                this.doctorMsg = {
                    icon: icon,
                    doctorTitle: doctorTitle,
                    doctorContent: doctorContent,
                    departmentName: departmentName,
                    doctorName: doctorName
                }
                this.imgList = imgList;
                this.caseList = medicalRecordList;
            }
        } catch (error){
            console.log('catch');
            console.log(error)

        } finally {
            this.isScrollFun();
        }
    }
}
